export const toMins = (seconds: number): number => {
  return Math.ceil(seconds.valueOf() / 60)
}

export const toKms = (meters: number): number => {
  return Math.ceil(meters.valueOf() / 1000)
}
